import { Environment } from './environment.type';

export const environment: Environment = {
  name: 'staging',
  production: false,
  adyen: {
    clientKey: 'test_SQ6WSUB5GFGNJFPOFXNNZ4V2E4EAX3PS',
    environment: 'test',
  },
  endpoints: {
    wombat: 'https://links-staging.kody.services',
    payByBank: 'https://paybybank-staging.kody.services',
    brandAssets: 'https://l-staging.kodypay.com/brands',
  },
  coralogix: {
    apiKey: 'cxtp_wqKKEsy4gobFvE5S2ny6IeJFViUne9',
    domain: 'EU2',
  },
  launchDarkly: {
    clientId: '62d80d287265001239878fc1',
  },
  googlePay: {
    countryCode: 'GB',
    environment: 'TEST',
    gatewayMerchantId: 'KodyPay_ECOM_BP',
    merchantId: 'BCR2DN4TU3J65FR4',
  },
};
